import { PDFViewer } from '@react-pdf/renderer';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getDownloadReceiptData } from '../../services/charging/charging-service';
import type { IVatReceipt } from '../../models/charging';
import type { ICommonProps } from '../../types/propTypes';
import NoDataReceipt from './NoDataReceipt';

const DownloadVATReceipt = (props: ICommonProps) => {
    const { t } = props;
    const { session_id } = useParams();
    const [receiptDetails, setReceiptDetails] = useState<IVatReceipt | null>(null);
    const [isAPICalled, setIsAPICalled] = useState<boolean>(false);

    useEffect(() => {
        if (session_id) {
            getReceiptData();
        }
    }, []);

    const getReceiptData = async () => {
        const inputData = {
            encrypted_session_id: session_id,
            is_download: false,
        };

        await getDownloadReceiptData(inputData)
            .then(async (res) => {
                const pdfDownloadLink = res.Data.invoice_url;
                if (pdfDownloadLink !== '') {
                    window.open(pdfDownloadLink, '_self');
                    setReceiptDetails(res.Data);
                    setTimeout(() => {
                        window.close();
                    }, 2000);
                }
            })
            .catch((_m) => {
                setReceiptDetails(null);
            })
            .finally(() => {
                setIsAPICalled(true);
            });
    };

    return (
        <>
            <div className="download-receipt-container">
                {!isAPICalled && (
                    <div className="loading-container">
                        <div className="download-spinner"></div>
                        <h2>{t('history.receipt.content.vatReceiptLoadingMessage')}</h2>
                        <p>{t('history.receipt.content.vatReceiptDownloadMessage')}</p>
                    </div>
                )}
                {isAPICalled && receiptDetails === null && (
                    <PDFViewer style={{ width: '100%', height: '800px' }}>
                        <NoDataReceipt t={t} />
                    </PDFViewer>
                )}
            </div>
        </>
    );
};
export default DownloadVATReceipt;
